'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.test = undefined;

var _mapValues = require('lodash/fp/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
  Before change value by updater. Intercept updater call to modify updating value

  modifier 的 signature 考慮

  - `props => value => modifiedValue`
  - `(value, props) => modifiedValue`

  目前似乎沒有 curry 的需求，不需事先把 props 存下來
  先當成第二個參數傳進去比較單純
*/

function checkUpdater(updater) {
  if (typeof updater !== 'function') {
    console.error('\n      modifyUpdatingValue: expect receive updater ' + name + '\n      but recieve ' + updater + '\n    ');
  }
}
function checkModifier(modifier) {
  if (typeof modifier !== 'function') {
    console.error('\n      modifyUpdatingValue: expect receive a higher-order function ' + name + '\n      it should create a modifier, but is ' + modifier + '\n    ');
  }
}

function toFunc(input) {
  return typeof input === 'function' ? input : function () {
    return input;
  };
}
function makeHandlerCreator(makeModifier, name) {
  return function (props) {
    return function (input, callback) {
      var updater = props[name];
      if (process.env.NODE_ENV !== 'production') checkUpdater(updater);

      var modifier = makeModifier(props);
      if (process.env.NODE_ENV !== 'production') checkModifier(modifier);

      updater(function (value) {
        return modifier(toFunc(input)(value), value);
      }, callback);

      /* another implementation, performance? */
      // if (typeof updater === 'function') {
      //   onChange(value => modifier(updater(value), value))
      // } else {
      //   onChange(value => modifier(updater, value))
      // }
    };
  };
}
var mapValuesWithKey = _mapValues2.default.convert({ cap: false });
var modifyUpdatingValue = mapValuesWithKey(makeHandlerCreator);

exports.default = modifyUpdatingValue;


var test = { makeHandlerCreator: makeHandlerCreator };
exports.test = test;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/modifyUpdatingValue.js
// module id = 1698
// module chunks = 0